import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=06e2303a&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=06e2303a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e2303a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06e2303a')) {
      api.createRecord('06e2303a', component.options)
    } else {
      api.reload('06e2303a', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=06e2303a&scoped=true&", function () {
      api.rerender('06e2303a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ZPHOyqfvQiI5/JS/comp/PopupDialog.vue"
export default component.exports